import * as React from 'react';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import I18N from 'src/services/I18NService';
import { FormComponentProps } from 'antd/lib/form';
import { IMallMedicineSearch, IMallPharmacyDetail, IMallCategory } from 'src/entity/MallEntity';

interface IMedicineSearchProps extends FormComponentProps {
  category: IMallCategory;
  pharmacyList: IMallPharmacyDetail[];
  cbSearch(query: IMallMedicineSearch): Promise<void>;
}

interface IMedicineSearchState {
  isClick: boolean;
}

class MedicineSearch extends React.Component<IMedicineSearchProps, IMedicineSearchState> {
  // 上架状态
  activeStatus = [
    { isActive: 1, name: `${I18N.get('common_status_active_on')}` },
    { isActive: 0, name: `${I18N.get('common_status_active_off')}` },
  ];
  constructor(props: IMedicineSearchProps) {
    super(props);

    this.state = {
      isClick: false,
    };
  }

  /**
   * 查询
   *
   * @memberof PharmacySearch
   */
  handleSearch = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (this.state.isClick) {
      return;
    }
    this.setState({
      isClick: true,
    });
    this.props.form.validateFields(async (err, values: IMallMedicineSearch) => {
      if (!err) {
        const query: IMallMedicineSearch = {
          name: values.name,
          short_name: values.short_name,
          code: values.code,
          medicine_group: values.medicine_group,
          category: this.props.category.code,
          is_deleted: false,
          offset: 0,
          limit: 10,
        };

        if (values.is_active !== undefined) {
          query.is_active = values.is_active === 1;
        }

        await this.props.cbSearch(query);
      }

      this.setState({
        isClick: false,
      });
    });
  };

  /**
   * 重置
   *
   * @memberof PharmacySearch
   */
  handleReset = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { pharmacyList, category } = this.props;

    return (
      <Form className="mdd-search-form" onSubmit={this.handleSearch}>
        <Row type="flex" align="middle">
          <div className="auto-flex-item">
            <Row gutter={24}>
              {/* 药库 */}
              <Col span={8}>
                <Form.Item label={I18N.get('common_pharmacy')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`medicine_group`)(
                    <Select allowClear={true} placeholder={`${I18N.get('common_choose')}${I18N.get('common_pharmacy')}`}>
                      {pharmacyList
                        .filter(t => t.category === category.code && !t.is_deleted)
                        .map(u => {
                          return (
                            <Select.Option key={u.uuid} value={u.uuid}>
                              {u.is_active ? u.name : `${u.name}(${I18N.get('common_status_disable')})`}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              {/* 药品名称 */}
              <Col span={8}>
                <Form.Item label={I18N.get('med_agent_name')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`name`)(<Input name="medicine-search-name" placeholder={`${I18N.get('common_input')}${I18N.get('med_agent_name')}`} />)}
                </Form.Item>
              </Col>
              {/* 药品简称 */}
              <Col span={8}>
                <Form.Item label={I18N.get('med_short_name')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`short_name`, {
                    initialValue: null,
                  })(<Input name="medicine-search-short-name" placeholder={`${I18N.get('common_input')}${I18N.get('med_short_name')}`} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: 10 }}>
              <Col span={8}>
                {/* 药品ID */}
                <Form.Item label={`${I18N.get('med_agent_code')}`} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`code`, {
                    initialValue: null,
                  })(<Input name="medicine-search-short-code" placeholder={`${I18N.get('common_input')}${I18N.get('med_agent_code')}`} />)}
                </Form.Item>
              </Col>
              {/* 上架状态 */}
              <Col span={8}>
                <Form.Item label={I18N.get('med_active_status')} style={{ marginBottom: 0 }}>
                  {getFieldDecorator(`is_active`)(
                    <Select allowClear={true} placeholder={`${I18N.get('common_choose')}`}>
                      {this.activeStatus
                        .map(s => {
                          return (
                            <Select.Option key={s.isActive} value={s.isActive}>
                              {s.name}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="fixed-flex-item flex-column" style={{ marginLeft: 30 }}>
            <Button type="primary" htmlType="submit">
              {I18N.get('common_search')}
            </Button>
            <Button style={{ marginTop: 16 }} onClick={this.handleReset}>
              {I18N.get('common_clear')}
            </Button>
          </div>
        </Row>
      </Form>
    );
  }
}

const MedicineSearchForm = Form.create<IMedicineSearchProps>()(MedicineSearch);
export default MedicineSearchForm;



// WEBPACK FOOTER //
// ./src/components/views/Mall/MedicineSearchForm.tsx